import React, {useRef, useEffect, useState} from 'react';
import Audience from '../components/Audience';

class Search extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            search: '',
            loading: false,
            result: [],
            length: "5",
            analysis: {},
            vector: "open-ai",
            type: "all",
            analyses: []
        };

        this.options = ["5", "10", "15", "20"];
        // this.analyses = [
        //     {"text": "AWA 2022", "id": "0010034201"},
        //     // {"text": "best for planning 2022 II (Basis: Deutschsprachige 14+ Jahre)", "id": "0760014222"},
        //     {"text": "best for planning 2022 II", "id": "0760014222"},
        // ];
        
        this.types = [
            {"text": "Alles (A, M, AQ, MO, MB)", "id": "all"},
            {"text": "Zielgruppen (A)", "id": "A"},
            {"text": "Numerische Zielgruppen (AQ)", "id": "AQ"},
            {"text": "Zielgruppen (A&AQ)", "id": "A,AQ"},
            {"text": "Medien (M)", "id": "M"},
            {"text": "Online Medien (MO)", "id": "MO"},
            {"text": "Medien (MB)", "id": "MB"},
            {"text": "Medien (M, MO, MB)", "id": "M,MO,MB"},
        ];

        this.vectors = [
            {"text": "open-ai - text-embedding-ada-002", "id": "open-ai"},
            // {"text": "text2vec-contextionary", "id": "text2vec"},
        ];

        this.state.length = this.options[0];

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onLengthChangeHandler = this.onLengthChangeHandler.bind(this);
        this.onAnalysisChangeHandler = this.onAnalysisChangeHandler.bind(this);
        this.onVectorChanged = this.onVectorChanged.bind(this);
        this.onTypeFilterChanged = this.onTypeFilterChanged.bind(this);


    }

    componentDidMount() {
        this.loadAnalysisInformations();
    }

    async loadAnalysisInformations() {
        this.setLoading(true);
        let response = fetch('https://llm-evaluation-api.comsulting.net/')
            .then(response => response.json())

        let data = await response;
        let analyses = data.supported.analyses.map((a, i) => {
            return { "text": a["title"], "id": a["analysisId"] }
        });

        this.setState({ analyses: analyses, analysis: analyses[0] });
        this.setLoading(false);
    }

    onVectorChanged(event) {
        this.setState({'vector': event.target.value})
        this.clearSearchResult();
    }

    onTypeFilterChanged(event) {
        let typeValue = [];
        if (event.target.value == "all") {
            typeValue = [];
        } else {
            typeValue = [event.target.value.split(",")];
        }

        this.setState({'type': typeValue})
        this.clearSearchResult();
    }

    handleSearchChange(event) {
        this.setState({'search': event.target.value})
    }

    setLoading(state) {
        this.setState({'loading': state})
    }

    setSearchResult(response) {
        this.setLoading(false);
        this.setState({
            'result': response.result.map((a, i) => {
                a.id = a.key;
                a.key = i;
                return a;
            })
        });
    }

    clearSearchResult(response) {
        this.setState({ 'result': [] });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.doSearch();
    }

    onAnalysisChangeHandler(event) {
        this.setState({'analysis': this.state.analyses.find((a) => a.id == event.target.value)})
        this.clearSearchResult();
    }

    onLengthChangeHandler(event) {
        this.setState({'length': event.target.value})
    }

    doSearch() {
        if (!this.state.search) {
            this.clearSearchResult();
            return;
        }


        return this.doPythiaSearch();

    }

    doPythiaSearch() {
        let params = {
            "search": this.state.search,
            "limit": parseInt(this.state.length),
            "analysis": this.state.analysis.id,
            "vector": this.state.vector,
            "type": this.state.type
        }

        const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(params) };
        fetch('https://llm-evaluation-api.comsulting.net/search/', requestOptions)
            .then(response => response.json())
            .then(this.setSearchResult.bind(this))
    }


    render() {
        return (
            <div class="container">
                <h1 class="mt-3">Pythia Suche - {this.state.analysis.text}</h1>

                <div class="main-form">
                    <form onSubmit={this.handleSubmit} className="mb-3">
                        <div class="row">
                            <div class="col">
                                <input type="text" class="form-control" value={this.state.search} onChange={this.handleSearchChange} />
                            </div>
                            {/* <div class="col-4 d-grid">
                                <button class="btn btn-outline-primary" onClick={this.doSearch}  type="submit">Suche!</button>
                            </div> */}
                        </div>

                        <div class="row mt-3">
                            {/* <div class="col-4">
                                <select class="form-select" onChange={this.onVectorChanged}>
                                    {this.vectors.map((option, index) => {
                                        return <option key={option.id} value={option.id}>
                                            {option.text}
                                        </option>
                                    })}
                                </select>
                            </div> */}
                            <div class="col-4">
                                <select class="form-select" onChange={this.onAnalysisChangeHandler}>
                                    {this.state.analyses.map((option, index) => {
                                        return <option key={option.id} value={option.id}>
                                            {option.text}
                                        </option>
                                    })}
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select" onChange={this.onTypeFilterChanged}>
                                    {this.types.map((option, index) => {
                                        return <option key={index}  value={option.id}>
                                            {option.text}
                                        </option>
                                    })}
                                </select>
                            </div>
                            <div class="col-2">
                                <select class="form-select" onChange={this.onLengthChangeHandler}>
                                    {this.options.map((option, index) => {
                                        return <option key={index}  value={option}>
                                            {option} Elemente
                                        </option>
                                    })}
                                </select>
                            </div>
                            <div class="col-4 d-grid">
                                <button class="btn btn-outline-primary" onClick={this.doSearch}  type="submit">Suche!</button>
                            </div>
                        </div>
                        <hr/>
                    </form>

                    { this.state.loading == false && (
                        <div class="row">
                            <div class="col result">
                                {this.state.result.map((el, index) => (
                                    <Audience {...el}></Audience>
                                ))}
                            </div>
                        </div>
                    )}

                    { this.state.loading == true && (
                        <div class="row">
                            <div class="col result">
                                Loading....
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Search;
